import { TagActiveStatus, TagsCreateBy } from "../../badge-and-tag";
import { Typography } from "antd";
import { EditableRow, EditableCell } from "../../table/TableEditAble";
import "../../../assets/styles/banks.css";
/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

export const parameterMicroColumns = ({ handleAction, nameOption }) => {
  return [
    {
      title: "Parameter Name",
      key: "paraname",
      dataIndex: "paraname",
      align: "left",
      width: 280,
    },
    {
      title: "Preparation Value",
      align: "left",
      width: 220,
      key: "preparation",
      dataIndex: "preparation",
    },
    // {
    //   title: "Cut Out Value",
    //   align: "left",
    //   width: 220,
    //   editable: true,
    //   required: false,
    //   key: "cutout",
    //   dataIndex: "cutout",
    //   className:"field-edit",
    //   type:'input',
    // },
    {
      title: "Remark",
      align: "left",
      key: "remark",
      dataIndex: "remark",
    },
  ];
};

export const parameterTreatmentColumns = ({ handleAction, nameOption }) => {
  return [
    {
      title: "Parameter Name",
      key: "paraname",
      dataIndex: "paraname",
      align: "left",
      width: 280,
    },
    {
      title: "Preparation Value",
      align: "left",
      width: 220,
      key: "preparation",
      dataIndex: "preparation",
    },
    // {
    //   title: "Cut Out Value",
    //   align: "left",
    //   width: 220,
    //   editable: true,
    //   required: false,
    //   key: "cutout",
    //   dataIndex: "cutout",
    //   className:"field-edit",
    //   type:'input',
    // },
    {
      title: "Remark",
      align: "left",
      key: "remark",
      dataIndex: "remark",
    },
  ];
};

export const columnsMicroParametersEditable = (
  handleSave,
  { handleAction, nameOption }
) => {
  const col = parameterMicroColumns({ handleAction, nameOption });
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
        };
      },
    };
  });
};

export const columns = ({ handleChoose }) => {
  const Link = Typography.Link;
  return [
    {
      title: "No.",
      key: "id",
      dataIndex: "id",
      align: "left",
      vertical: "middle",
      width: 60,
      render: (_, record, index) => index + 1,
    },
    {
      title: "Treatment Name",
      key: "tm_name",
      dataIndex: "tm_name",
      align: "left",
      render: (v, record) => (
        <Link className="text-select" onClick={() => handleChoose(record)}>
          {" "}
          {v}
        </Link>
      ),
    },
    {
      title: "Status",
      dataIndex: "active_status",
      key: "active_status",
      width: "20%",
      render: (v, record) => (
        <Link className="text-select" onClick={() => handleChoose(record)}>
          {" "}
          {v}
        </Link>
      ),
    },
    {
      title: "จัดทำโดย",
      dataIndex: "created_name",
      key: "created_name",
      sorter: (a, b) => a.created_name.localeCompare(b.created_name),
      width: "20%",
      ellipsis: {
        showTitle: false,
      },
      render: (data, role) => (
        <TagsCreateBy
          result={data}
          role={role}
          onClick={() => handleChoose(role)}
        />
      ),
    },
  ];
};

export const initialSteps = [
  { step_name: "Step 1", editable: true },
  { step_name: "Step 2", editable: true },
  { step_name: "Step 3", editable: true },
];
